{
  "valid": "Kehtiv"
}
